import React, { Children } from 'react';
import { motion } from 'framer-motion';
interface PilotSlide2AProps {
  isDark?: boolean;
}
export function PilotSlide2A({
  isDark = false
}: PilotSlide2AProps) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  const columns = ['Heliona', 'BetterUp / EZRA', 'Lyra / Spring', 'Culture Amp / Korn Ferry', 'Masterclass / Headspace'];
  const rows = [{
    dimension: 'Primary Focus',
    values: ['Leaders Only', 'All Employees', 'Clinical (All)', 'All Employees', 'All Employees']
  }, {
    dimension: 'Approach',
    values: ['Preventive', 'Coaching', 'Reactive', 'Surveys', 'Content Library']
  }, {
    dimension: 'Assessment',
    values: ['Psychometric', 'Psychometric', 'Intake Only', 'Engagement', 'None']
  }, {
    dimension: 'Development',
    values: ['Integrated', 'Standalone', 'None', 'None', 'Self-Paced']
  }, {
    dimension: 'Care Navigation',
    values: ['Assessment-Driven', 'None', 'Self-Select', 'None', 'None']
  }, {
    dimension: 'Pipeline Integration',
    values: ['Full', 'Standalone', 'Standalone', 'Standalone', 'Standalone']
  }];
  return <motion.div className="h-full w-full overflow-y-auto overflow-x-hidden" variants={containerVariants} initial="hidden" animate="visible" data-id="element-562">
      <div className="min-h-full flex flex-col justify-center max-w-7xl mx-auto px-4 sm:px-12 py-20 sm:py-24" data-id="element-563">
        <motion.div variants={itemVariants} className="mb-10 sm:mb-14 text-center" data-id="element-564">
          <h1 className={`text-3xl sm:text-5xl font-serif font-medium mb-5 sm:mb-6 tracking-tight ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-565">
            What Companies Already Pay For
          </h1>
          <p className={`text-base sm:text-xl max-w-3xl mx-auto ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-566">
            Multiple fragmented tools and none built specifically for leaders
          </p>
        </motion.div>

        {/* Comparison Table */}
        <motion.div variants={itemVariants} className="w-full overflow-x-auto mb-10 sm:mb-14" data-id="element-567">
          <table className="w-full min-w-[700px]" data-id="element-568">
            {/* Header */}
            <thead data-id="element-569">
              <tr data-id="element-570">
                <th className={`text-left py-4 px-4 sm:px-5 text-xs sm:text-sm font-semibold tracking-wider uppercase ${isDark ? 'text-white/50' : 'text-heliona-text-gray/70'}`} data-id="element-571">
                  Dimension
                </th>
                {columns.map((col, idx) => <th key={idx} className="py-4 px-3 sm:px-4 text-center" data-id="element-572">
                    {idx === 0 ? <span className="inline-block px-5 py-2 rounded-lg bg-heliona-mint text-heliona-navy font-bold text-sm sm:text-base" data-id="element-573">
                        {col}
                      </span> : <span className={`text-xs sm:text-sm font-semibold ${isDark ? 'text-white/70' : 'text-heliona-text-gray'}`} data-id="element-574">
                        {col}
                      </span>}
                  </th>)}
              </tr>
            </thead>

            {/* Body */}
            <tbody data-id="element-575">
              {rows.map((row, rowIdx) => <tr key={rowIdx} className={rowIdx % 2 === 0 ? isDark ? 'bg-white/[0.02]' : 'bg-heliona-beige/30' : ''} data-id="element-576">
                  <td className={`py-4 sm:py-5 px-4 sm:px-5 text-sm sm:text-base font-bold ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-577">
                    {row.dimension}
                  </td>
                  {row.values.map((val, colIdx) => <td key={colIdx} className="py-4 sm:py-5 px-3 sm:px-4 text-center" data-id="element-578">
                      <span className={`text-sm sm:text-base ${colIdx === 0 ? isDark ? 'text-heliona-mint font-semibold' : 'text-heliona-mint-dark font-semibold' : isDark ? 'text-white/70' : 'text-heliona-charcoal'}`} data-id="element-579">
                        {val}
                      </span>
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </motion.div>

        {/* Footer */}
        <motion.div variants={itemVariants} className="text-center mb-16 sm:mb-0" data-id="element-580">
          <p className={`text-sm sm:text-lg italic leading-relaxed max-w-4xl mx-auto ${isDark ? 'text-white/60' : 'text-heliona-text-gray/80'}`} data-id="element-581">
            Heliona is the only platform offering an integrated, preventive,
            assessment-driven pipeline specifically for people leaders.
          </p>
        </motion.div>
      </div>
    </motion.div>;
}